( function( ) {
	$(document).foundation();
}) ( );
